export const CHARACTER_RELATE_CONTAIN: { [key: string]: string } = {
  CONTAIN: "contain",
  SHARE: "share",
  PART: "part",
  BUILD_WORD_EXPRESSION: "build_word_expression",
};
